var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDirectorySmall = function SvgDirectorySmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 1.334h12v11.333H1zm6.333 9.999a4.333 4.333 0 1 0 0-8.667 4.333 4.333 0 0 0 0 8.667m-.001-3.335a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6.336-4.664h1.333v11.333H3v-1.333h10.668z",
    clipRule: "evenodd"
  })));
};
export default SvgDirectorySmall;